






















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Form as ElForm, Input } from 'element-ui';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'Login',
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: (error?: Error) => void) => {
    if (value.length < 4) {
      callback(new Error('用户名长度至少为 4 位'));
    } else {
      callback();
    }
  };
  private validatePassword = (rule: any, value: string, callback: (error?: Error) => void) => {
    if (value.length < 6) {
      callback(new Error('密码长度至少为 6 位'));
    } else {
      callback();
    }
  };
  private loginForm = {
    username: '',
    password: '',
  };
  private loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
  };
  private passwordType = 'password';
  private loading = false;
  private showDialog = false;
  private redirect?: string;
  private otherQuery: any = {};

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    const query = route.query as any;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }

  private mounted() {
    if (this.loginForm.username === '') {
      (this.$refs.username as Input).focus();
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus();
    }
  }

  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = '';
    } else {
      this.passwordType = 'password';
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus();
    });
  }

  private async handleLogin() {
    const valid = await (this.$refs.loginForm as ElForm).validate();
    if (valid) {
      this.loading = true;
      setTimeout(() => (this.loading = false), 0.5 * 1000);
      await UserModule.Login(this.loginForm);
      this.$router.push({
        path: this.redirect || '/',
        query: this.otherQuery,
      });
    } else {
      return false;
    }
  }

  private jAccount() {
    let pathname = process.env.NODE_ENV === 'production' ? '/admin' : '';
    if (location.pathname.startsWith('/en')) {
      pathname = '/en' + pathname;
    }
    window.location.href = `https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=essential&client_id=51AScw9vNVF41VwJrCqj&redirect_uri=${location.origin}${pathname}/cb`;
  }

  private getOtherQuery(query: any) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur];
      }
      return acc;
    }, {} as any);
  }
}
